<template>
<transition name="slide-fade">
    <div class="dialog-view" v-show="visible">        
        <div class="rule-modal u-window">           
            <div class="dialog-content">              
                <div class="u-btn close" @click="destroyElement"></div>
                <div class="dialog-wrapper">
                    <div class="dialog-title t-rule"></div>

                    <div class="rules">
                        <div class="rule-text">
                            <p v-for="(item,index) in rule" :key="index"><em class="tag" v-html="index+1"></em> <span v-html="item.text"></span></p>
                        </div>
                    </div>


                </div>
            </div>
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>    
</template>

<script>
export default {
    name : 'evt_rule_modal',
    data : function () {
        return {
            visible : false,
            rule_text :{
                'evt' : [
                    {
                        tag : '',
                        text : '每日登录游戏即可解锁两条线索。',
                    },
                    {
                        tag : '',
                        text : '邀请好友一起来找寻线索可额外获得线索。',
                    },
                    {
                        tag : '',
                        text : '通过以上线索选择你认为的“盗剑之人”即可获得追查礼包。',
                    },
                    {
                        tag : '',
                        text : '成功找出“盗剑之人”还可获得额外缉拿礼包。',
                    },
                    {
                        tag : '',
                        text : '每人只有一次确认盗剑之人的机会，一旦选定，无法更改。',
                    },                                                            
                ],
                'share' : [
                    {
                        tag : '活动时间',
                        text : '2022/7/4 至 2022/7/24',
                    },
                    {
                        tag : '玩法说明',
                        text : '活动期间,分享页面,当其他仙术师通过分享链接登录界面即为助力成功。',
                    },                    
                ],
            },
            type : 'evt',          
        }
    },
    computed :{
        rule (newVal){
            return this.rule_text[this.type]
        },        
    },    
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    methods: {
        destroyElement () {
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },
    }    
}
</script>

<style scoped>

    .rule-modal{
        width: 734px;
        height: 426px;
        background-image: url(~@/assets/images/pc/bg-modal-bind.png);
    }

    .u-btn.close{
        top: 25px;
        right: 40px;
        width: 32px;
        height: 34px;
        background-image: url(~@/assets/images/pc/vote/btn-close.png);
    }   


    .t-rule{
        width: 138px;
        height: 33px;
        margin: 0 auto 15px;
        background-image: url(~@/assets/images/pc/title-rule.png);
    }

    .rule-text{
        margin-top: 40px;
    }

    .rule-text p{
        position: relative;
        color: #f2edd9;
        line-height: 1.6;
        padding-left: 50px;
        margin: 10px 60px;
        font-size: 20px;
    }

    .rule-modal p .tag{
        display: block;
        position: absolute;
        left: 0;
        top: 10px;
        width: 14px;
        height: 14px;
        background-image: url(~@/assets/images/pc/icon-index.png);
        color: transparent;
        font-size: 0;
        text-align: center;
    }
    
    .notice{
        margin-top: 35px;
        text-align: center;
        color: #f2edd9;
    }    


</style>


// WEBPACK FOOTER //
// src/components/EvtRule/EvtRule.vue